import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'complement-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.scss']
})
export class ComplementPhoneComponent implements OnInit {

  constructor() { }

  @Input() template : any = 'default';
  @Input() data : {};

  ngOnInit() {
  }

}